var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display3d"},[_c('div',{staticStyle:{"background-color":"black"},attrs:{"id":"map"}}),_c('div',{attrs:{"id":"backBtn"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("退出3D浏览")])])
}
var staticRenderFns = []

export { render, staticRenderFns }